export const OPTHINES = {
  voteName: '2019poject/2019shangyou_questions/',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#f0e8bb',
    inactiveBgColor: '#f4a842',
  },
  tabs: [
    {
      tabName: '首页',
      tabPath: '/2019QuestionMaster/first',
    },
    {
      tabName: '提问',
      tabPath: '/2019QuestionMaster/second',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019QuestionMaster/third',
    },
  ],
};
